import React from 'react'
import './nav.css'
import { AiOutlineHome } from "react-icons/ai"
import { AiOutlineUser } from "react-icons/ai"
import { VscTools } from "react-icons/vsc"
import { SlFolderAlt } from "react-icons/sl"
import { BiBook } from "react-icons/bi"
import { SlGraduation } from "react-icons/sl"
import { RiHandHeartLine } from "react-icons/ri"
import { SlBadge } from "react-icons/sl"
import { LuMessageSquare } from "react-icons/lu"
import { useState } from 'react'

const Nav = () => {
  var [navActive , setNavActive] = useState("#")
  return (
    <nav>
      <a href="#" onClick={() => setNavActive("#")} className={navActive === "#" ? 'active' : ''}><AiOutlineHome /></a>
      <a href="#about" onClick={() => setNavActive("#about")} className={navActive === "#about" ? 'active' : ''}><AiOutlineUser /></a>
      <a href="#skills" onClick={() => setNavActive("#skills")} className={navActive === "#skills" ? 'active' : ''}><VscTools /></a>
      <a href="#projects" onClick={() => setNavActive("#projects")} className={navActive === "#projects" ? 'active' : ''}><SlFolderAlt /></a>
      <a href="#expriences" onClick={() => setNavActive("#expriences")} className={navActive === "#expriences" ? 'active' : ''}><BiBook /></a>
      <a href="#educations" onClick={() => setNavActive("#educations")} className={navActive === "#educations" ? 'active' : ''}><SlGraduation /></a>
      <a href="#services" onClick={() => setNavActive("#services")} className={navActive === "#services" ? 'active' : ''}><RiHandHeartLine /></a>
      <a href="#certifications" onClick={() => setNavActive("#certifications")} className={navActive === "#certifications" ? 'active' : ''}><SlBadge /></a>
      <a href="#contact" onClick={() => setNavActive("#contact")} className={navActive === "#contact" ? 'active' : ''}><LuMessageSquare /></a>
    </nav>
  )
}

export default Nav